/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconArrowsDiagonalMinimize = createReactComponent("outline", "arrows-diagonal-minimize", "IconArrowsDiagonalMinimize", [["path", { "d": "M6 10h4v-4", "key": "svg-0" }], ["path", { "d": "M4 4l6 6", "key": "svg-1" }], ["path", { "d": "M18 14h-4v4", "key": "svg-2" }], ["path", { "d": "M14 14l6 6", "key": "svg-3" }]]);

export { IconArrowsDiagonalMinimize as default };
//# sourceMappingURL=IconArrowsDiagonalMinimize.mjs.map
